import { grcAppBaseUrl } from "../../config/GlobalConfig";
import useAppState from "../../context/AppContext";


export default function ConfirmModificationFormComponent() {
  
    const {
      state: { proposition },
    } = useAppState();

    return (
        <form>
          <p className="text">Vos modifications ont été enregistrées. Veuillez cliquer sur le bouton pour rediriger vers GRC</p>
          <a className="cta-bleu mt-lg" href={`${grcAppBaseUrl}&forceUCI=1&pagetype=entityrecord&etn=quote&id=${proposition!.propositionId}`}>Rediriger</a>
        </form>
    );

}